var generateStyle = function generateStyle(componentTheme) {
  return {
    tipTitle: {
      fontWeight: componentTheme.tipTitleFontWeight,
      '&:not(:first-child)': {
        paddingTop: componentTheme.tipTitlePadding
      }
    }
  };
};
export default generateStyle;